import { render, staticRenderFns } from "./generate.vue?vue&type=template&id=70c34ab8&scoped=true"
import script from "./generate.vue?vue&type=script&lang=js"
export * from "./generate.vue?vue&type=script&lang=js"
import style0 from "./generate.vue?vue&type=style&index=0&id=70c34ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c34ab8",
  null
  
)

export default component.exports